import React from 'react';
import { number, oneOfType, string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { hasNoLimit } from '../../../util/insuranceDetails';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ deductibleAmountIndividualInNetwork: Valid... Remove this comment to see the full error message
class Coinsurance extends Base {
  static propTypes = {
    deductibleAmountIndividualInNetwork: oneOfType([number, string]).isRequired,
  };

  static isVisible = () => true;

  icon = '/images/insurance_tutorial/09_coinsurance.svg';

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
  hasNoDeductible = () => hasNoLimit(this.props.deductibleAmountIndividualInNetwork);

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'deductibleAmountIndividualInNetwork' doe... Remove this comment to see the full error message
    const { deductibleAmountIndividualInNetwork } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Let's go splitsies</H2>
            {this.hasNoDeductible() && (
              <P>
                Since your plan doesn't have a deductible, you'll pay for a percentage of your care
                and your insurance will cover the rest until you've hit your out-of-pocket max
              </P>
            )}
            {!this.hasNoDeductible() && (
              <P>
                It's called co-insurance. Once you've hit your{' '}
                <b>${deductibleAmountIndividualInNetwork}</b> deductible, you pay a percentage for
                your care and your insurance pays the rest.
              </P>
            )}
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Coinsurance;
